import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppSelector } from "src/hooks/redux";
import Vix from "./vix";
const VixWrapper = () => {
    const showIframe = useAppSelector((state) => state.commonReducer.disableChartsIframe);
    return _jsx(_Fragment, { children: showIframe && _jsx(Vix, { id: "india-vix" }) });
};
export default VixWrapper;
